import React, { useState, useEffect } from 'react';
import Container from '../ui/Container';
import Button from '../ui/Button';
import AnnouncementBar from './AnnouncementBar';
import { NAV, APP, LOGO } from './siteData';

const cx = (...c) => c.filter(Boolean).join(' ');

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <>
    <header
      data-testid="marketing-header"
      className={cx(
        'sticky top-0 z-50 backdrop-blur-md bg-white/80 transition-all duration-300 border-b',
        scrolled ? 'border-line shadow-soft' : 'border-transparent',
      )}
    >
      <AnnouncementBar />

      <Container className="flex items-center gap-7 h-[72px]">
        <a href="/" aria-label="Shopstar home" className="flex-none">
          <img src={LOGO.blue} alt="Shopstar" height="28" className="h-7 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-1 ml-2" aria-label="Primary">
          {NAV.map((item) => (
            <a key={item.href} href={item.href} className="px-3.5 py-2 rounded-xl text-[0.95rem] font-semibold text-ink/70 hover:text-ink hover:bg-cream transition-colors">
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4 ml-auto">
          <a href={APP.signIn} className="text-[0.95rem] font-semibold text-ink/70 hover:text-ink transition-colors">Sign in</a>
          <Button href={APP.signUp} size="sm" icon={false}>Start for free</Button>
        </div>

        <button
          type="button"
          className="lg:hidden ml-auto flex flex-col justify-center gap-[5px] w-11 h-11 p-2.5"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span className={cx('block h-[2.5px] w-full bg-ink rounded transition-transform duration-300 ease-spring', open && 'translate-y-[7.5px] rotate-45')} />
          <span className={cx('block h-[2.5px] w-full bg-ink rounded transition-opacity', open && 'opacity-0')} />
          <span className={cx('block h-[2.5px] w-full bg-ink rounded transition-transform duration-300 ease-spring', open && '-translate-y-[7.5px] -rotate-45')} />
        </button>
      </Container>
    </header>

      {/* Mobile drawer — intentionally a SIBLING of <header>, not a child. The
          header sets `backdrop-blur-md` (a backdrop-filter), and any
          filter / backdrop-filter / transform ancestor becomes the containing
          block for `position: fixed` descendants. Nested inside, this drawer was
          sized against the ~128px header instead of the viewport, so
          `top-… bottom-0` collapsed it to zero height and nothing showed. As a
          sibling it pins to the viewport as intended. */}
      <div className={cx('lg:hidden fixed inset-x-0 top-[128px] sm:top-[116px] bottom-0 z-40 bg-white overflow-y-auto transition-transform duration-300 ease-spring', open ? 'translate-x-0' : 'translate-x-full')} aria-hidden={!open}>
        <nav className="flex flex-col p-6 gap-1" aria-label="Mobile">
          {NAV.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setOpen(false)} className="py-3.5 px-1 text-lg font-bold text-ink border-b border-cream">
              {item.label}
            </a>
          ))}
          <div className="flex flex-col gap-3 mt-6">
            <Button href={APP.signIn} variant="secondary" full icon={false}>Sign in</Button>
            <Button href={APP.signUp} full>Start for free</Button>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
